import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ShopifyEcommerceExpertsInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Shopify E-commerce Experts in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Your Shopify Partner</Subheading>}
        heading={
          <Heading>
            Shopify <span tw="text-primary-500">E-commerce Experts</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we are Shopify e-commerce experts in **Dubai**,
            specializing in creating high-performing, user-friendly online
            stores tailored to your brand. Let us elevate your business with our
            Shopify expertise.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556155092-490a1ba16284?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce website on laptop
          "https://images.unsplash.com/photo-1661956602944-249bcd04b63f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Shopify logo and brand
          "https://images.unsplash.com/photo-1577401158266-39c8a0e37d58?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Online shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Shopify Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Shopify Solutions in Dubai"
        description="We deliver Shopify stores that drive success."
        cards={[
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Store Setup",
            description: "Tailored Shopify stores to match your vision.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Conversion Driven",
            description: "Optimized designs to boost sales.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Scalable Platforms",
            description: "Grow seamlessly with Shopify Plus.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Stores",
            description: "Safe and reliable e-commerce solutions.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimized",
            description: "Flawless experience on all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Experts",
            description: "Dubai’s top Shopify professionals.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Shopify Development Process"
        description={
          <Description>
            We craft your Shopify store with expertise:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Align with your business goals.</li>
              <li>Design: Create a branded, user-friendly layout.</li>
              <li>Development: Build custom features and apps.</li>
              <li>Integration: Seamless payment and POS systems.</li>
              <li>Launch: Deploy a high-performing store.</li>
              <li>Support: Ongoing optimization and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1590935217180-77701fc6b476?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce development process
          "https://images.unsplash.com/photo-1565106430482-8f6e74349ca1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team working on digital projects
          "https://images.unsplash.com/photo-1523726491678-bf852e717f6a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Product photography for e-commerce
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Shopify Success in Dubai"
        description="Our expertise transforms businesses."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Surge",
            description: "Shopify store boosted revenue by 200%.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Launch",
            description: "Live store in just 10 days.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "98% approval for Shopify projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Shine Online?</Subheading>}
        heading="Shopify E-commerce Experts in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset, Dubai’s leading Shopify e-commerce
            experts. Build a powerful, scalable online store that drives
            results—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplashWooCommerceDevelopmentServicesInDubai.js.com/photo-1516321165247-4aa89a48be28?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Successful business team
          "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Woman happily using laptop for online shopping
          "https://images.unsplash.com/photo-1561069934-eee225952461?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
